<template>
  <div class="container">
       <a-drawer  placement="right" :closable="false"  :width="1200"
       :visible="applyVisible"  :after-visible-change="afterVisibleChange" @close="onClose">
            <template slot="title">
               <div class="rightTop">
                  <div style="font-weight:700;">发起申请</div>
                  <div>
                    <!-- <a href="https://obx0ep5l37.feishu.cn/docx/Jdctd0K5foLboAxVL5TcB197nff" target="_blank" style="margin-right: 5px;"> -->
                    <a href="https://obx0ep5l37.feishu.cn/wiki/TcoJwaj2mi9MqLkTaOIcWa0BnQd" target="_blank" style="margin-right: 5px;">
                      <a-icon type="question-circle" />帮助手册
                    </a>
                    <a href="https://obx0ep5l37.feishu.cn/wiki/wikcnbaFDULfDgQzjhKHeJzfyHg" target="_blank">
                      <a-icon type="message" />反馈
                    </a>
                  </div>
               </div>
            </template>
       <div class="containerTop">
           <!-- 基础信息模块 -->
           <div>
               <div class="title">
                    <span>基础信息</span>
                </div>
                <div style="margin: 10px;">
                    <div>
                        <span>付款类别：</span>
                        <div style="margin-top: 10px; width: 60%;" >
                            <a-cascader style="width: 85%" :options="options"  :show-search="{ filterOption }" v-model="formData.BaseInformation.paymentId" 
                            placeholder="请选择" @change="getModel($event)"  :field-names="{ label: 'name', value: 'id', children: 'child' }" disabled/>
                                <!-- <a-cascader  v-model="form.location" :options="LocationList" placeholder="请选择" @change="choseLocation" popupStyle="50px"/> -->
                                <a-tooltip placement="topLeft" v-if="paymentId != undefined">
                                    <template slot="title">
                                        <div v-if="formData.BaseInformation">{{formData.BaseInformation.mark}}</div>
                                    </template>
                                    <span style="color: rgb(245, 165, 46); font-size: 18px; margin-left: 15px;"><a-icon type="info-circle" /></span>
                                </a-tooltip>
                        </div>
                    </div>
                </div>
                <div class="xuxian1"></div>
           </div>
            <!-- 申请模板 -->
            <div v-if="formData.BaseInformation">
                <div>
                    <!-- 关联项目信息 -->
                    <div  v-if="formData.BaseInformation.isCheckInformation" class="box">
                            <div class="title">
                                <span>关联项目信息</span>
                            </div>
                            <div class="centerBox">
                                <a-table :data-source="formData.BaseInformation.information_relate" bordered :pagination="false">
                                    <a-table-column  key="project_name" title="项目名称"  data-index="project_name" style="color:red;">
                                        <template slot-scope="text, record" >
                                        <a-input v-model="record.project_name" placeholder="请输入" ></a-input>
                                        </template>
                                    </a-table-column>
                                    <a-table-column key="project_code" title="项目编号"  data-index="project_code">
                                        <template slot-scope="text, record" >
                                        <a-input v-model="record.project_code" placeholder="请输入" ></a-input>
                                        </template>
                                    </a-table-column>
                                    <a-table-column key="projece_pay" title="项目金额（元）*"  class="line"  data-index="projece_pay">
                                        <template slot-scope="text, record" >
                                        <a-input v-model="record.projece_pay" placeholder="请输入"  oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"></a-input>
                                        </template>
                                    </a-table-column>
                                        <a-table-column key="amount" title="已付金额" data-index="amount">
                                        <template slot-scope="text, record" >
                                        <a-input v-model="record.amount" placeholder="请输入" ></a-input>
                                        </template>
                                    </a-table-column>
                                    <a-table-column title="操作" width="70px">
                                        <template slot-scope="text, record, index">
                                            <a  class="line" href="#" @click="removeProject(index)">移除</a>
                                        </template>
                                    </a-table-column>
                                </a-table>
                            </div>
                            <div class="feeDetail">
                                <a-button class="addFee" type="dashed" icon="plus" block @click="addProject"> 新增项目信息 </a-button>
                            </div>
                    </div>
                    <!-- 费用金额 -->
                    <div class="expenses" v-if="formData.detail">
                        <div class="expensesTitle" >
                            <div>
                                <span>付款金额</span>
                            </div>
                            <div>
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <div>本次付款金额，为您填写的各【明细金额】合计</div>
                                    </template>
                                    <a-icon type="info-circle" style="margin-right: 10px;"/>本次总金额：<span style="color: rgb(247, 126, 28);">{{allprojectMoney}}</span>元整
                                </a-tooltip>
                                
                            </div>
                        </div>
                    <!-- 循环费用明细 -->
                    <div v-for="(item1, index1) in formData.detail" :key="index1">
                        <div class="expensesTop">
                            <div class="expensesTitle">
                                <span>付款明细({{index1 + 1}})</span>
                            </div>
                            <div class="xuxian"></div>
                            <!-- <a-divider dashed style="width: 70%;"/> -->
                            <div style="color:red; margin-left:5px"> 
                                    <a-icon type="delete" class="but_type" style="color:red" title="删除" @click="deleteItem(index1)"/>删除
                            </div>
                        </div>
                        <div class="expensesCenter">
                                <!-- <a-form-model :model="item1"  ref="ruleFormFixation"  > -->
                                    <div v-for="(item, index) in item1" :key="index" style="margn: 10px;">
                                            <div style="padding: 5px;">
                                                <span style="margin-right:5px;">{{item.label}}</span>
                                                <span v-if="item.required" style="color:red;">*</span>
                                            </div>
                                            <div style="margin-bottom: 5px;">
                                                <!-- <a-form-model-item :label="item.label" style="margin-top:10px;"> -->
                                            <!-- 明细金额 -->
                                                <a-input v-if="item.type == 'Text' && item.index_name == 'detail_money'" v-model="item.value" :placeholder="item.content" allowClear style="width:60%;" 
                                                @change="countDetail"  oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                                                <!-- 输入框 -->
                                                <a-input v-if="item.type == 'Text' && item.index_name != 'detail_money'" v-model="item.value" :placeholder="item.content" allowClear style="width:60%;"></a-input>
                                                <!-- 数字输入框 -->
                                                <a-input v-if="item.type == 'Number' && item.index_name != 'detail_money'" v-model="item.value" :placeholder="item.content" allowClear style="width:60%;" 
                                                    oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                                                <!-- 时间选择 -->
                                                <a-date-picker v-model="item.value" valueFormat="YYYY-MM-DD" :placeholder="item.content" allowClear 
                                                v-if="item.type == 'Date'" style="width:60%;"/>
                                                <!-- 单选 -->
                                                <div  v-if="item.type == 'Redio'" >
                                                        <a-select show-search allowClear placeholder="请选择" class="margin_self" v-model="item.value" style="width:60%;" >
                                                        <a-select-option v-for="(item2, index) in item.array" :key="index" :value="item2">
                                                            {{ item2 }}
                                                        </a-select-option>
                                                    </a-select>
                                                    <!-- <a-radio-group v-model="item.value" >
                                                        <a-radio v-for="(item2, index) in item.array" :key="index" :value="item2">
                                                            {{item2}}
                                                        </a-radio>
                                                    </a-radio-group> -->
                                                </div>
                                            <!-- 多行文本 -->
                                                <a-input v-if="item.type == 'Textarea'" v-model="item.value" type="textarea" style="width:60%;"/>
                                                <!-- 费用归属部门 -->
                                                    <div v-if="formData.BaseInformation.isFeeDept && item.type == 'DeptInformation'">
                                                    <!-- <div  class="title">
                                                    <span>{{item.label}}<span style="color:red;"> * </span></span>
                                                    </div> -->
                                                    <div >
                                                        <a-cascader style="width: 60%"   :field-names="{ label: 'title', value: 'value', children: 'children' }"
                                                        :options="departmentList"  :show-search="{ filterOption }" v-model="item.value" placeholder="归属公司/部门"/>
                                                        <!-- <a-tree-select allowClear :tree-data="departmentList" placeholder="部门名称"  style="width: 300px; margin-right: 5px" 
                                                            v-model="department_id">
                                                        </a-tree-select> -->
                                                    </div>
                                                </div>
                                                <!-- 差旅费 -->
                                                <div v-if="item.type == 'array'">
                                                    <div v-if="applyVisible">
                                                        <div class="travelBoxTop">
                                                            <div  style="width: 45%; border-right: 1px solid #dedfdf;">
                                                                <div class="travelContetTop">出差起始地</div>
                                                                <div class="travelContetBottom">
                                                                    <a-cascader v-model="item.travelData.location_start" :options="LocationList" placeholder="请选择省/市" @change="choseLocation" popupStyle="50%"/>
                                                                    至
                                                                    <a-cascader v-model="item.travelData.location_end" :options="LocationList" placeholder="请选择省/市" @change="choseLocation" popupStyle="50%"/>
                                                                </div>
                                                            </div>
                                                            <div  style="width: 15%; border-right: 1px solid #dedfdf;">
                                                                <div class="travelContetTop">天数</div>
                                                                <div class="travelContetBottom">
                                                                    <a-input v-model="item.travelData.days" oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" placeholder="请输入" allowClear style="width:100%;"></a-input>
                                                                </div>
                                                            </div>
                                                            <div  style="width: 40%;">
                                                                <div class="travelContetTop">起止日期</div>
                                                                <div class="travelContetBottom">
                                                                    <a-date-picker v-model="item.travelData.time_start" valueFormat="YYYY-MM-DD" placeholder="开始日期" /> ~ 
                                                                    <a-date-picker v-model="item.travelData.time_end" valueFormat="YYYY-MM-DD" placeholder="结束日期" />
                                                                    <!-- <a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 100%;" allowClear :value="dates" @change="onChange(index,index1)" 
                                                                    :placeholder="['开始时间', '结束时间']" /> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="travelBoxCenter borderStyle borderBottom">
                                                            <div style="width: 50%; border-right: 1px solid #dedfdf; ">
                                                                <div class="travelContetTop">异地交通费</div>
                                                                <div class="layoutbox">
                                                                    <div style="width: 33.3%;">
                                                                        <div class="travelContetTop ">飞机</div>
                                                                        <div  class="travelContetBottom">
                                                                            <a-input v-model="item.travelData.plane_fee" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入金额" allowClear style="width:100%;" @change="countTotal(index,index1)"></a-input>
                                                                        </div>
                                                                        </div>
                                                                    <div style="width: 33.3%;">
                                                                        <div class="travelContetTop borderStyle">火车</div>
                                                                        <div  class="travelContetBottom borderStyle">
                                                                            <a-input v-model="item.travelData.train_fee" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入金额" allowClear style="width:100%;" @change="countTotal(index,index1)" ></a-input>
                                                                        </div>
                                                                    </div>
                                                                    <div style="width: 33.4%;">
                                                                        <div class="travelContetTop">大巴</div>
                                                                        <div  class="travelContetBottom">
                                                                            <a-input v-model="item.travelData.bus_fee" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入金额" allowClear style="width:100%;" @change="countTotal(index,index1)" ></a-input>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style="width: 50%; ">
                                                                <div class="travelContetTop">同城交通费</div>
                                                                    <div class="layoutbox">
                                                                    <div style="width: 33.3%;">
                                                                    <div class="travelContetTop ">地铁</div>
                                                                    <div  class="travelContetBottom">
                                                                            <a-input v-model="item.travelData.subway_fee" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入金额" allowClear style="width:100%;" @change="countTotal(index,index1)"></a-input>
                                                                    </div>
                                                                </div>
                                                                <div style="width: 33.3%;">
                                                                    <div class="travelContetTop borderStyle">公交</div>
                                                                    <div  class="travelContetBottom borderStyle">
                                                                            <a-input v-model="item.travelData.transit_fee" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入金额" allowClear style="width:100%;" @change="countTotal(index,index1)"></a-input>
                                                                    </div>
                                                                </div>
                                                                <div style="width: 33.4%;">
                                                                    <div class="travelContetTop">出租</div>
                                                                    <div  class="travelContetBottom">
                                                                            <a-input v-model="item.travelData.taxi_fee" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入金额" allowClear style="width:100%;" @change="countTotal(index,index1)"></a-input>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="travelCenter borderStyle borderBottom">
                                                            <div class="contener">住宿费</div>
                                                            <div class="travelContetBottom contenerBox">
                                                                    <a-input v-model="item.travelData.live_fee" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入金额" allowClear style="width:100%;" @change="countTotal(index,index1)"></a-input>
                                                            </div>
                                                            <div class="contener">出差补贴</div>
                                                            <div class="travelContetBottom">
                                                                    <a-input v-model="item.travelData.travel_fee" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入（补助标准：每人/天，50元）" allowClear style="width:160%;" @change="countTotal(index,index1)"></a-input>
                                                            </div>
                                                            
                                                        </div>
                                                        <div class="travelCenter borderStyle borderBottom">
                                                            <div class="contener">其他费用</div>
                                                            <div class="travelContetBottom contenerBox">
                                                                    <a-input v-model="item.travelData.other_fee" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入金额（如，高速通行费、停车费等）" allowClear style="width:100%;" @change="countTotal(index,index1)"></a-input>
                                                            </div>
                                                                <div class="contener">小计(元)</div>
                                                            <div class="travelContetBottom">
                                                                    <a-input v-model="item.travelData.total" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入" allowClear style="width:160%;" disabled></a-input>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                        <!-- </a-form-model-item> -->
                                            </div>
                                            
                                        
                                    </div>
                                <!-- </a-form-model> -->
                                
                            </div>
                    
        
                    </div>
                    <div class="feeDetail">
                            <a-button class="addFee" type="dashed" icon="plus" block @click="addCost"> 增加费用明细 </a-button>
                    </div>

                    <!-- 发票信息 -->
                    <!-- <invoice v-if="formData.BaseInformation.isCheckBill"></invoice> -->
                    <div v-if="formData.BaseInformation.isCheckBill" class="invoiceBox">
                            <div class="title">
                                <div>
                                    <span>发票信息</span>
                                </div>
                            </div>
                            <div class="invoiceCenter">
                                    <a-table :data-source="formData.BaseInformation.bill_information" bordered :pagination="false">
                                    <!-- <a-table-column key="index" title="序号" data-index="index" width="70px">
                                        <template scope="text, record, index">{{ index + 1 }}</template>
                                    </a-table-column> -->
                                    <a-table-column  key="bill_code" title="发票代码 * " class="line" data-index="bill_code" >
                                        <template slot-scope="text, record,index">
                                            <a-input v-model="record.bill_code" placeholder="请输入" @blur="checkNum(record,index)" onKeyUp="value=value.replace(/[\W]/g,'')"></a-input>
                                        </template>
                                    </a-table-column>
                                    <a-table-column key="bill_number" title="发票号码 * " class="line" data-index="bill_number">
                                        <template slot-scope="text, record,index">
                                            <a-input v-model="record.bill_number" placeholder="请输入"  @blur="checkNum(record,index)"  onKeyUp="value=value.replace(/[\W]/g,'')"></a-input>
                                        </template>
                                    </a-table-column>
                                    <a-table-column key="bill_check" title="发票重复提交判断" data-index="bill_check" />
                                        <!-- <template slot-scope="text, record">
                                        <a-input v-model="record.bill_check" placeholder="请输入"></a-input>
                                        </template>
                                    </a-table-column> -->
                                    <a-table-column key="bill_type" title="发票类型" data-index="bill_type">
                                        <template slot-scope="text, record">
                                            <a-select show-search allowClear placeholder="请选择发票类型" class="margin_self" v-model="record.bill_type"
                                            @keyup.enter.native="query" style="width: 200px" >
                                            <a-select-option :value="item.title" v-for="(item, index) in invoiceList" :key="index">
                                                {{ item.title }}
                                                </a-select-option>
                                            </a-select>
                                        </template>
                                    </a-table-column>
                                    <a-table-column key="bill_money" title="发票金额（元）" data-index="bill_money">
                                        <template slot-scope="text, record">
                                        <a-input v-model="record.bill_money" placeholder="请输入" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></a-input>
                                        </template>
                                    </a-table-column>
                                    <a-table-column key="bill_date" title="开票日期" data-index="bill_date">
                                        <template slot-scope="text, record">
                                                <a-date-picker v-model="record.bill_date" valueFormat="YYYY-MM-DD" placeholder="请选择" allowClear />
                                        <!-- <a-input v-model="record.bill_date" placeholder="请输入" oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"></a-input> -->
                                        </template>
                                    </a-table-column>
                                    <a-table-column key="bull_attach" title="发票附件" data-index="bull_attach"  width="110px">
                                        <template slot-scope="text, record, index">
                                            <a href="#" @click="uploadEvent(record,index)">上传</a>
                                            <a-divider type="vertical" />
                                            <a href="#" @click="previewEvent(record,index)">预览</a>
                                        </template>
                                    </a-table-column>
                                    <a-table-column key="name" title="操作" data-index="name" width="70px">
                                        <template slot-scope="text, record, index">
                                            <a  class="line" href="#" @click="removeBill(index)">移除</a>
                                        </template>
                                    </a-table-column>
                                </a-table>
                            </div>
                                
                            <div class="billBottom">
                                <a-button class="addBill" type="dashed" icon="plus" block @click="addBill" > 新增发票 </a-button>
                            </div>
                        </div>
                    <!-- 关联审批信息 -->
                    <div class="box" v-if="formData.BaseInformation.isRelationAudit == true || formData.BaseInformation.isRelationPurchase == true">
                            <div class="title">
                                <span>关联审批信息</span>
                            </div>
                            <div class="centerBox">
                                <div v-if="this.formData.BaseInformation.isRelationAudit" style="display: inline; margin-right: 10px;">
                                    <a-button type="primary" @click="showAuditCode" > 查询审批单 </a-button>
                                </div>
                                <a-button type="primary" @click="showPurchase" v-if="this.formData.BaseInformation.isRelationPurchase"> 查询采购单 </a-button>
                            </div>
                            <div class="centerBottom">
                                <div class="bottom" v-if="this.formData.BaseInformation.isRelationAudit">
                                    <a-table :data-source="approvalData" bordered :pagination="false">
                                    <a-table-column  key="applyCode" title="申请单号"  data-index="applyCode" />
                                    <a-table-column key="processName" title="申请标题"  data-index="processName"/>
                                    <a-table-column key="applyer" title="申请人"  data-index="applyer"/>
                                    <a-table-column key="applyerTime" title="申请时间"  data-index="applyerTime"/>
                                    <a-table-column key="result" title="审批结果"  data-index="result">
                                    <template scope="text,record">
                                            <a-tag :color="result_apply[record.result].color">
                                                {{result_apply[record.result].txt}}
                                            </a-tag>
                                    </template>
                                    </a-table-column>
                                    <a-table-column title="操作" >
                                        <template slot-scope="text, record, index">
                                            <a @click="approvalDelete(record, index)">取消关联</a>
                                        </template>
                                    </a-table-column>
                                </a-table>
                                </div>
                                <div class="bottom" v-if="this.formData.BaseInformation.isRelationPurchase">
                                    <a-table :data-source="purchaseData" bordered :pagination="false">
                                    <a-table-column  key="applyCode" title="申请单号"  data-index="applyCode" />
                                    <a-table-column key="name" title="物品名称"  data-index="name"/>
                                    <a-table-column key="model" title="规格型号"  data-index="model"/>
                                    <a-table-column key="amount" title="数量"  data-index="amount"/>
                                    <a-table-column key="unit" title="单位"  data-index="unit"/>
                                    <a-table-column key="isInvalid" title="申购状态"  data-index="isInvalid">
                                        <template scope="text,record">
                                            <a-tag class="span" :color="record.isInvalid == 1 ? 'red' : 'green'">
                                            {{ record.isInvalid == 1 ? '作废' : '正常' }}
                                            </a-tag>
                                        </template>
                                    </a-table-column>
                                    <a-table-column key="result" title="审批结果"  data-index="result">
                                    <template scope="text,record">
                                            <a-tag :color="result_apply[record.result].color">
                                                {{result_apply[record.result].txt}}
                                            </a-tag>
                                    </template>
                                    </a-table-column>
                                    <a-table-column key="name" title="操作"  data-index="name">
                                        <template slot-scope="text, record, index">
                                            <a @click="purchaseDelete(record, index)">取消关联</a>
                                        </template>
                                    </a-table-column>
                                </a-table>

                                </div>

                            </div>
                            <selectAuditCode :kind="kind" ref="selectAuditCode" :approvalId="approvalId" @getDataList="getDataList" :newApply="newApply"
                                :data="{ auditCodeData, auditCodeData2, auditCodeData3, auditCodeData4 , auditCodeData5 }" :selectIndex="1"
                                @applyData="getAppCode"
                                @applyData2="getAppCode2"
                                @applyData3="getAppCode3"
                                @applyData4="getAppCode4"
                                @applyData5="getAppCode5"
                            />
                            </div>
                    <!-- <account></account> -->
                </div>
                    <div class="box" v-if="formData.BaseInformation">
                    <div class="title">
                        <span>申请备注信息</span>
                    </div>
                    <div style="margin: 10px;">
                        <div style="margin: 10px 0;">备注说明</div>
                        <div>
                            <a-textarea v-model="formData.BaseInformation.remark" placeholder="选填，请输入申请说明或相关备注信息" 
                            :auto-size="{ minRows: 2, maxRows: 5 }" style="width:50%;" />
                        </div>
                        <div style="margin: 10px 0;">特殊备注(此信息不会进行打印)</div>
                        <div>
                            <a-textarea v-model="formData.BaseInformation.tips" placeholder="选填，此备注信息不会在【申请表】中打印出来，仅作为此申请的备注使用"
                            :auto-size="{ minRows: 2, maxRows: 5 }" style="width:50%;" />
                        </div>
                    </div>
                </div>
                </div>
                <!-- 附件/图片管理 -->
                <!-- <enclosure></enclosure> -->
                <div class="box">
                    <!-- 附件图片管理 -->
                        <div class="title">
                        <span>附件管理<span style="font-weight: 400;">(除发票以外的凭证附件)</span></span>
                        </div>
                        <div class="center">
                            <div class="left">
                                <div style="margin-bottom: 10px;">图片上传:</div>
                                <uploadImgJava :data="uploadDataImg" v-if="applyVisible"/>
                            </div>
                            <div class="right">
                                <div style="margin-bottom: 10px;">文件上传:</div>
                                <uploadFileCode :data="uploadData" v-if="applyVisible"/>
                            </div>
                        </div>
                </div>
            <!-- 账户信息 -->
            <div class="centerBottom">
                <div class="title">
                    <div>
                        <span>申请人/账户信息</span>
                    </div>
                </div>
                <div class="bottom">
                    <a-table :data-source="account_information" bordered :pagination="false">
                        <a-table-column  key="goodsType" title="所属公司 * " class="line" data-index="goodsType" >
                            <template slot-scope="text, record">
                                <a-select show-search allowClear placeholder="公司名称" class="margin_self" @change="handlecompany" v-model="record.company_id"
                                :disabled="formData.BaseInformation.isControllerSelf" style="width: 200px" >
                                    <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
                                    {{ item.title }}
                                    </a-select-option>
                                </a-select>
                            </template>
                        </a-table-column>
                        <a-table-column  key="goodsType" title="所属部门 * " class="line" data-index="goodsType" >
                            <template slot-scope="text, record">
                                <a-tree-select allowClear :tree-data="deptList" placeholder="部门名称"  style="width: 200px; margin-right: 5px" @change="leaderid"
                                :disabled="!record.company_id  || formData.BaseInformation.isControllerSelf"  v-model="record.dept_id">
                                </a-tree-select>
                            </template>
                        </a-table-column>
                        <a-table-column key="name" title="申请人" data-index="name">
                            <template slot-scope="text, record">
                                <a-select showSearch allowClear class="margin_self" :disabled="!record.dept_id || formData.BaseInformation.isControllerSelf" placeholder="申请人"
                                    v-model="record.apply" @change="getName" style="width: 200px; margin-right: 5px">
                                    <a-select-option :value="item.userName" v-for="(item, index) in plainOptions" :key="index">
                                        {{ item.userName }}
                                    </a-select-option>
                                </a-select>
                            <!-- <a-input v-model="record.apply" placeholder="请输入"></a-input> -->
                            </template>
                        </a-table-column>
                        <a-table-column  title="转账账户 *" class="line">
                            <template slot-scope="text, record">
                                <a-select allowClear class="margin_self" v-model="record.reimbursement_account" style="width: 200px;"
                                    @change="changeform($event)" @dropdownVisibleChange="changeT" @blur="changeF" placeholder="请输入"  
                                    show-search :filter-option="filterOption">
                                        <div slot="dropdownRender" slot-scope="menu">
                                            <v-nodes :vnodes="menu" />
                                            <a-divider style="margin: 4px 0" />
                                            <div
                                                style="padding: 4px 8px; cursor: pointer; color: #1890ff"
                                                @mousedown="(e) => e.preventDefault()"
                                                @click="alert"
                                            >
                                                <a-icon type="plus" /> 添加账户
                                            </div>
                                        </div>
                                        <a-select-option :value="item.id" v-for="(item, index) in banklist" :key="index" :title="item.titleData">
                                            {{item.titleData}}
                                    
                                            <!-- <span style="font-weight: 700;" >
                                                {{ item.name }}
                                            </span>
                                            {{ item.bank }} {{ item.accountNum }} -->
                                            <span style="float: right; color: #1890ff" v-show="bankshow" @click="bankclear(item.id)">清除</span>
                                        </a-select-option>
                                    </a-select>
                            </template>
                        </a-table-column>
                    </a-table>
                    <a-table :data-source="applyData" bordered :pagination="false">
                        <a-table-column  key="goodsType" title="抄送人" data-index="goodsType" >
                            <template slot-scope="text, record">
                                <ccChange ref="ccChange" :data="ccC" :money="moneY" @targetKeys="getdata" />
                            </template>
                        </a-table-column>
                    </a-table>
                </div>
            </div>
            </div>
            <div :style="{   position: 'absolute',   right: 0,   bottom: 0,   width: '100%',   borderTop: '1px solid #e9e9e9',   padding: '10px 16px', background: '#fff',  textAlign: 'right', zIndex: 1,}" >
              <a-button :style="{ marginRight: '8px' }"  type="primary" @click="submit"> 提交申请 </a-button>
              <a-button @click="onClose"> 取消 </a-button>
            </div>
          
       </div>
       
       </a-drawer>
       <!-- 发票上传与预览 -->
        <a-modal class="gufiiguy" title="文件管理" :visible="fileVisible" @cancel="closeRecords" width="40%" @ok="addRecords" >
            <div class="boxCenter" v-if="uploadType == 0">
                <!-- <div class="left">
                    <div style="margin-bottom: 10px;">图片上传:</div>
                    <uploadImgJava  v-if="fileVisible" ref="uploadImgJava" :data="billDataImg" :typeIndex="1" @getBillImg="getBillImg" />
                </div> -->
                <div class="right">
                    <div style="margin-bottom: 10px;">文件上传:</div>
                    <uploadFileCode v-if="fileVisible" ref="uploadFileCode" :data="billData" :typeIndex="1" @getBillAttach="getBillAttach"/>
                </div>
            </div>
             <div class="boxCenter" v-else>
                <!-- <div class="left">
                    <div style="margin-bottom: 10px;">图片预览:</div>
                     <div class="view_path_img" style="display: flex; justify-content: space-between"
                        v-for="(item, index) in vouchers" :key="index">
                        <div class="view_path_img_margin"></div>
                        <div class="view_path_img_center" style="height: 60%; width:60% ; padding: 10px;">
                              <img :src="item.preUrl" @click="show_img(index, vouchers)" />
                        </div>
                    </div>
                </div> -->
                <div style="width: 100%; ">
                    <div style="margin-bottom: 10px;">文件预览:</div>
                    <div
                        class="view_path"
                        @click="previewFile(item)"
                        v-for="(item, index) in appendix"
                        :key="index"
                    >
                                {{ item.name }}
                    </div>
                    <!-- <uploadFileCode :data="uploadData" /> -->
                </div>
            </div>
            <preview ref="preview" />
        </a-modal>
          <a-modal v-model="bankvisible" title="添加账号" width="50%"  @cancel="bankvisible = false" @ok="handleOk">
            <!-- <template slot="footer">
                <a-button key="back" @click="bankvisible = false"> 取消 </a-button>
                <a-button key="submit" type="primary" @click="handleOk"> 提交 </a-button>
            </template> -->
            <div class="topBox">
                <div
                class="topItem"
                @click="changeItem(index)"
                :style="{ color: tIdx == index ? '#409EFF' : '' }"
                v-for="(item, index) in accs"
                :key="index"
                >
                {{ item.title }}
                </div>
            </div>
            <div class="centerBank">
                <div class="c_item">
                <div class="title">户名：</div>
                <a-input class="aInput" v-model="form.name" allowClear placeholder="请输入"></a-input>
                </div>
                <div class="c_item">
                <div class="title">账号：</div>
                <a-input class="aInput" v-model="form.accountNum" allowClear placeholder="请输入"></a-input>
                </div>
                <div class="c_item" v-if="accs[this.tIdx].id == 1 || accs[this.tIdx].id == 2">
                <div class="title">银行：</div>
                <a-input class="aInput" v-model="form.bank" placeholder="请输入" allowClear></a-input>
                </div>
                <div class="c_item" v-if="accs[this.tIdx].id == 2">
                <div class="title">地址：</div>
                <a-select class="selectAds" v-model="form.province" allowClear placeholder="请选择" @change="changePro">
                    <a-select-option :value="item.id" v-for="(item, index) in pros" :key="index">
                    {{ item.extName }}
                    </a-select-option>
                </a-select>
                <a-select class="selectAds" :disabled="!form.province" v-model="form.city" allowClear placeholder="请选择">
                    <a-select-option :value="item.id" v-for="(item, index) in cits" :key="index">
                    {{ item.extName }}
                    </a-select-option>
                </a-select>
                </div>
                <div class="c_item" v-if="accs[this.tIdx].id == 2">
                <div class="title">银行支行：</div>
                <a-input class="aInput" v-model="form.branchBank" placeholder="请输入" allowClear></a-input>
                </div>
            </div>
    </a-modal>
         <!-- <a-modal v-model="bankvisible" title="添加新收款账户" @ok="bankOk" width="400px" style="text-align: center">
            <a-tabs default-active-key="1" @change="callback">
                <a-tab-pane key="1" tab="支付宝账号">
                <a-form-model :model="bankform" :label-col="labelCol2" :wrapper-col="wrapperCol2">
                    <a-form-model-item label="户名">
                    <a-input v-model="bankform.name" />
                    </a-form-model-item>
                    <a-form-model-item label="账号">
                    <a-input v-model="bankform.accountNum" type="number" />
                    </a-form-model-item>
                </a-form-model>
                </a-tab-pane>
                <a-tab-pane key="2" tab="个人银行卡">
                <a-form-model :model="bankform" :label-col="labelCol2" :wrapper-col="wrapperCol2">
                    <a-form-model-item label="户名">
                    <a-input v-model="bankform.name" />
                    </a-form-model-item>
                    <a-form-model-item label="卡号">
                    <a-input v-model="bankform.accountNum" type="number" />
                    </a-form-model-item>
                    <a-form-model-item label="银行">
                    <a-input v-model="bankform.bank" />
                    </a-form-model-item>
                </a-form-model>
                </a-tab-pane>
            </a-tabs>
    </a-modal> -->
  </div>
</template>

<script>
import { getPaymentDetail } from '@/api/financial'
import { tree_all } from '@/api/purchase'
import { floatAdd }from '@/utils/precision'
import {  getDeptListEnable3 } from '@/api/system.js'
import { get_accounts_receivable, accounts_receivable_save, accounts_receivable_delete, get_list_enable} from '@/api/activiti'
import { download_file_java } from '@/utils/request'
import { resolveBlob } from '@/utils/index'
import { get_users2 } from '@/utils/unit_axios'
import preview from '@/components/module/prview'
import uploadFileCode from '@/components/module/uploadFileCode.vue'
import uploadImgJava from '@/components/module/uploadImgJava.vue'
import { limitCompany } from '@/utils/limitCompany'
import selectAuditCode from '@/components/module/selectAuditCode.vue'
import { audit_list,postApply,payment_apply_code,checkDup ,directoryListAll, templateList, isApply} from '@/api/financial'
import enclosure from './enclosure.vue'
import ccChange from '@/components/module/ccChange'
import projecModelt from './projecModelt.vue'
// import invoice from './invoice.vue'
import relation from './relation.vue'
import {directoryList, getTemplateById} from '@/api/donate'
import { districts} from '@/api/Industry'
export default {
     components: {
        projecModelt,
        // invoice,
        relation,
        ccChange,
        enclosure,
        selectAuditCode,
        uploadImgJava,
        uploadFileCode,
        preview,
         VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    }
    },
    data() {
        return {
            newApply: 0,
            tips: '',
            dates: [],
            departmentList: [],
            // department_id: [],
            LocationList: [],
            List: ['jack', 'lucy'],
            banklist: [],
            labelCol2: {
                span: 3,
            },
            wrapperCol2: {
                span: 21,
            },
            bankform: {
                name: '',
                accountNum: '',
                bank: '',
            },
            typesnum: 1,
            bankshow: true,
            appendix: [],
            vouchers: [],
            typeIndex: 1,
            plainOptions: [],
            fileIndex: undefined,
            uploadType: undefined,
            fileVisible: false,
            billData: {
                code: '',
                type: 'bill-appendix',
            },
            billDataImg: {
                 code: '',
                type: 'bill-img',
            },
            uploadData: {
                code: '',
                type: 'payment-appendix',
            },
            uploadDataImg: {
                code: '',
                type: 'payment-certificate',
            },
            allprojectMoney: '',
            projectMoney: 0,
            deptList: [],
            companylist: [],
            remark: '',
            kind: undefined,
            typeIndex: undefined,
            Approvallist: [],
            typeList: [],
            approvalData: [],
            purchaseData: [],
            approvalId: undefined,
            auditCodeData: [],
            auditCodeData2: [],
            auditCodeData3: [],
            auditCodeData4: [],
            auditCodeData5: [],
            //发票信息
             bill_information: [{
                bill_code: '', 
                bill_number: '',
                bill_check: '',
                bill_type: undefined,
                bill_money: '',
                bill_date: '',
                bill_img: [],
                bill_attach: [],
                bill_attach_id: '',
                bill_img_id: '',
            }],
            invoiceList: [{
                value: 1,
                title: '电子增值税普通发票',
            },{
                value: 2,
                title: '电子增值税专用发票',
            },{
                value: 3,
                title: '增值税普通发票',
            },{
                value: 4,
                title: '增值税专用发票',
            },{
                value: 5,
                title: '其他发票',
            },{
                value: 6,
                title: '预付/其他',
            }],
            // 关联项目信息
            information_relate: [
                {
                    project_name: '',
                    project_code: '',
                    projece_pay: '',
                    amount: '',
                }
            ],
        labelCol: {
          span: 3,
         },
         wrapperCol: {
           span: 21,
         },
         modelData: [],
            //整个表单数据
            formData: [],
            paymentId: undefined,
            cc: '',
            ccsData: [],
            ccC: '',
            account_information: [{
                company_id: this.$store.getters.userInfo.companyId,
                dept_id: this.$store.getters.userInfo.dept.deptId,
                apply: this.$store.getters.userInfo.userName,
                reimbursement_account: undefined,
            }],
            applyData: [{
                name: 1,
            }],
            options: [],
            applyVisible: false,
            bankvisible: false,
             accs: [{
                 id: 0,
                 title: '支付宝账号',
             },{
                 id: 1,
                 title: '个人银行卡',
             } , {
                 id: 2,
                 title: '对公银行账号'
             }],
            tIdx: 0,
            form: {
                name: '', //	户名
                accountNum: '', //	账号（卡号）
                bank: '', //	银行
                province: undefined, //	支行地址（省）
                city: undefined, //	支行地址（市）
                branchBank: '', //	银行支行
            },
            pros: [],
            cits: [],
            dataDetail1:[],
            dataDetail2:[],
            travelData: {
                    location_start: '',
                    location_end: '',
                    days: '',
                    time_start: '',
                    time_end: '',
                    plane_fee: '',
                    train_fee: '',
                    bus_fee: '',
                    subway_fee: '',
                    transit_fee: '',
                    taxi_fee: '',
                    live_fee: '',
                    travel_fee: '',
                    other_fee: '',
                    total: '',
                        }
        }
    },
    created() {
        tree_all().then((res) => {
            if (res.code == 200) {
               this.departmentList = res.data[0]
            }
        })
         audit_list({
             source: 1
         }).then((res) => {
        if (res.code == 200) {
        //   res.data.splice(12, 1)
          this.Approvallist = res.data
          console.log(this.Approvallist, 'this.Approvallist')
        }
      })
       limitCompany().then(res=>{
            res.forEach(item => {
               if(item.deptId){
                 this.companylist.push(item)
                  for (let i = 0; i < this.companylist.length; i++) {
                    if(this.account_information[0].company_id == this.companylist[i].deptId){
                            this.deptList = this.companylist[i].children
                            break
                        }
                    }
               }
            })
            // this.leaderid(this.account_information.dept_id)
            get_users2(this.$store.getters.userInfo.dept.deptId, (res) => {
					this.plainOptions = res
					console.log(this.plainOptions,'this.plainOptions++++++++++++++++++++++')
				})
		 })
         
         getDeptListEnable3().then(res => {
             this.ccsData = res.rows
         })
         this.getAddres()
          // 获取地区数据
        districts().then((res) => {
            const list = res.data.tree
            list.forEach( item => {
            item.value = item.extName
            item.label = item.extName
            if(item.children) {
                item.children.forEach( item1 => {
                    item1.value = item1.extName
                    item1.label = item1.extName
                    delete item1['children']
                    // item1.children.forEach( item2 => {
                    //     item2.value = item2.extName
                    //     item2.label = item2.extName
                    //     if(item2.children.length == 0) {
                    //         delete item2['children']
                    //     }
                    // })
                })
            
            }else {
                delete item['children']
            }


            })   
            this.LocationList = list 
            console.log( this.LocationList , ' this.LocationList ================')
        })
	

    },
    methods: {
        // 移除项目信息
        removeProject(index) {
            this.formData.BaseInformation.information_relate.splice(index, 1)
        },
        //增加项目信息
        addProject() {
            var data = {
                    project_name: '',
                    project_code: '',
                    projece_pay: '',
                    amount: '',
                }
           this.formData.BaseInformation.information_relate.push(data)
        },
         onChange(date,index,index1) {
             console.log(date,'date, dateString, index,index1=================')
            this.dates = date
            console.log(this.dates, 'dates===============')
            // this.formData.detail[index1].array[index].time_start = date[0]
            // this.formData.detail[index1].array[index].time_end = date[1]
        },
        //下拉框查询
        filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
        // filter(inputValue, path) {
        //     return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        // },
        getDataList(data) {
            console.log(data, 'data====================')
            if(data == 1) {
             this.purchaseData = this.dataDetail1 
             this.approvalData = this.dataDetail2
            }
        },
        //   获取地址
        getAddres() {
            get_list_enable({
                deep: 0,
                pid: 0,
            }).then((res) => {
                this.pros = res.rows
                console.log(res, 'pros=======================')
            })
        },
        //切换省
        changePro() {
            get_list_enable({
                deep: 1,
                pid: this.form.province,
            }).then((res) => {
                this.form.city = undefined
                this.cits = res.rows
            })
        },
        //切换类型
            changeItem(index) {
            this.tIdx = index
            this.form = {
                name: '', //	户名
                accountNum: '', //	账号（卡号）
                bank: '', //	银行
                province: undefined, //	支行地址（省）
                city: undefined, //	支行地址（市）
                branchBank: '', //	银行支行
            }
            },
        //添加银行账号
         handleOk() {
            var accountType = ''
            var obj = {}
            switch (this.accs[this.tIdx].id) {
                case 0:
                accountType = 1
                obj = {
                    name: this.form.name, //	户名
                    accountNum: this.form.name,
                }
                break
                case 1:
                accountType = 2
                obj = {
                    name: this.form.name, //	户名
                    accountNum: this.form.name,
                    bank: this.form.bank,
                }
                break
                case 2:
                accountType = 3
                obj = {
                    name: this.form.name, //	户名
                    accountNum: this.form.name,
                    bank: this.form.bank,
                    province: this.form.province,
                    city: this.form.city,
                    branchBank: this.form.branchBank,
                }
                break
            }
            var is = 0
            for (let k in obj) {
                if (!obj[k]) {
                is = 1
                }
            }
            if (is) {
                this.$message.error('请将' + this.accs[this.tIdx].title + '信息填写完整')
                return
            }
            this.form['accountType'] = accountType
            accounts_receivable_save(this.form).then((res) => {
                if (res.code != 200) {
                this.$message.error(res.msg)
                return
                }
                this.$message.success('提交成功')
                this.bankvisible = false
                this.get_acc()
            })
            },
        //校验发票
        checkNum(record, index){
            console.log(index, 'index=========================')
                  if(record.bill_code!=='' && record.bill_number != '') {
                 checkDup({
                        bullCode: record.bill_code,
                        billNumber: record.bill_number,
                    }).then(res => {
                        if(res.code == 200){
                            if(res.data) {
                                this.formData.BaseInformation.bill_information[index].bill_check = '否'
                            } else {
                                this.formData.BaseInformation.bill_information[index].bill_check = '是'
                                this.formData.BaseInformation.$message.error('系统判断此发票可能存在【重复提交】请确认后再进行发起！')
                                this.formData.BaseInformation.bill_information[index].bill_check = ''
                                this.formData.BaseInformation.bill_information[index].bill_code = ''
                                this.formData.BaseInformation.bill_information[index].bill_number = ''
                            }

                        }

                    })
            }

        },
        bankclear(id) {
            var that = this
            this.$confirm({
                title: '警告',
                content: '确认删除此账号?',
                okText: '删除',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                let list = []
                list.push(id)
                accounts_receivable_delete(list).then((res) => {
                    if (res.code == 200) {
                    // that.form.accountNum = 
                    that.account_information[0].reimbursement_account = undefined
                    that.get_acc()
                    }
                  })
                },
                onCancel() {
                console.log('Cancel')
                },
            })
            },
        callback(key) {
            this.typesnum = key
            this.bankform = {}
            },
        //提交账户
         bankOk() {
            this.bankform['accountType'] = this.typesnum
            accounts_receivable_save(this.bankform).then((res) => {
                if (res.code == 200) {
                this.bankvisible = false
                this.get_acc()
                this.bankform = {}
                }
            })
            },
        //添加收款账号
        alert() {
            // this.accs = ['支付宝账号', '个人银行卡', '对公银行账号']
            this.accs = [{
                 id: 0,
                 title: '支付宝账号',
             },{
                 id: 1,
                 title: '个人银行卡',
             } , {
                 id: 2,
                 title: '对公银行账号'
             }]
            if(!this.formData.BaseInformation.isAlipay) {
                for(var i = 0; i <  this.accs.length; i++ ){
                    if( this.accs[i].title === '支付宝账号'){
                          this.accs.splice(i,1)
                    }
                }
            }
            if (this.formData.BaseInformation.isControllerSelf) {
                for(var i = 0; i <  this.accs.length; i++ ){
                    if( this.accs[i].title === '对公银行账号'){
                          this.accs.splice(i,1)
                    }
                }

            }
          this.bankvisible = true
        },
         get_acc() {
             var data = ''
             if(this.formData.BaseInformation.isAlipay) {
                 data = 23
             } else if(this.formData.BaseInformation.isControllerSelf) {
                 data = 12
             } else {
                 data = null
             }
            get_accounts_receivable({
                types: data,
            }).then((res) => {
                console.log(res.data, 1)
                res.data.forEach(item => {
                    Object.assign(item , {
                        titleData: item.name + ' '+ item.bank + ' ' + item.accountNum
                    })
                })
                this.banklist = res.data
                console.log(this.banklist, 'banklist==========================')
            })
            },
         changeF() {
            this.bankshow = false
            },
            changeT() {
            this.bankshow = true
            },
        //账户校验
         changeform(e) {
            console.log(e, 'e=========================')
            console.log(this.banklist, 'banklist==========================')
            console.log(this.account_information[0].reimbursement_account, 'this.account_information[0].reimbursement_account================')
            this.bankshow = false
            if(this.formData.BaseInformation.isControllerSelf) {
                this.banklist.forEach((item) => {
                if (item.id == e) {
                if(item.name == this.account_information[0].apply) {
                    this.Select = item
                } else {
                    this.Select = {}
                    this.account_information[0].reimbursement_account = undefined
                    this.$message.warning('请选择与当前用户名一致的账户！')
                }
                
                }
            })

            }
     
    },
        async previewFile(file) {
                let path = '/' + file.url.split('/')[0] + '/'
                let fileName = file.url.substring(file.url.indexOf('/') + 1)
                var res = await download_file_java(file.types, path, fileName)
                var file_s_n = file.name.split('.')
                let type = file_s_n[file_s_n.length - 1]
                resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
                },
        //获取对应的文件id
        getBillAttach(data) {
            console.log(data, 'data=======================')
            this.formData.BaseInformation.bill_information[this.fileIndex].bill_attach = data
            this.formData.BaseInformation.bill_information[this.fileIndex].bill_attach_id = data.id

        },
        //获取图片对应的id
        // getBillImg(data) {
        //     console.log(data, 'data=======================')
        //     this.bill_information[this.fileIndex].bill_img = data
        //     this.bill_information[this.fileIndex].url = data.url
        //     this.bill_information[this.fileIndex].bill_img_id = data.id
        // },
        //获取人名
        getName(e) {

        },
        //选择部门的人
        leaderid(id) {
				console.log(id,'id++++++++++++++++++++++')
				get_users2(id, (res) => {
					this.plainOptions = res
					console.log(this.plainOptions,'this.plainOptions++++++++++++++++++++++')
				})
			},
        //图片预览
        show_img(idx, imgs) {
            var row = {
                index: idx,
                imgs: imgs,
            }
            this.$refs.preview.show(row)
        },
        //发票管理弹窗提交
        addRecords() {
            this.fileVisible = false

        },
        // 关闭发票管理弹窗
        closeRecords() {
             this.fileVisible = false

        },
        //上传发票文件
        uploadEvent(record, index) {
            this.fileIndex = index
            this.fileVisible = true
            this.uploadType = 0

        },
        //预览发票
        previewEvent(record, index) {
            // this.vouchers = []
            // this.vouchers.push({})
            // Object.assign(this.vouchers[0], {
            //     name: this.bill_information[index].bill_img.fileName,
            //     id: this.bill_information[index].bill_img.id,
            //     url: this.bill_information[index].bill_img.path,
            //     preUrl: this.bill_information[index].bill_img.url,

            // })
            this.appendix = []
            this.appendix.push({})
            Object.assign(this.appendix[0], {
                fileName: this.bill_information[index].bill_attach.fileName,
                name:  this.bill_information[index].bill_attach.fileName,
                id: this.bill_information[index].bill_attach.id,
                url: this.bill_information[index].bill_attach.path,
                types: 'bill-appendix',
                preUrl: this.bill_information[index].bill_attach.url,

            })
            console.log(this.appendix, 'appendix=====================')
            this.fileVisible = true
            this.uploadType = 1
            
        },
        numFormat(num) {
            num = parseFloat(num)
            return (num.toString().indexOf ('.') !== -1) ?
            num.toLocaleString():
            num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
            return num
        },
        //小计计算
        countTotal(index,index1){
              var num = 0
             var data = this.formData.detail[index1]
               num = floatAdd(num, Number(data[index].travelData.plane_fee))  
               num = floatAdd(num, Number(data[index].travelData.train_fee)) 
               num = floatAdd(num, Number(data[index].travelData.bus_fee)) 
               num = floatAdd(num, Number(data[index].travelData.subway_fee)) 
               num = floatAdd(num, Number(data[index].travelData.transit_fee)) 
               num = floatAdd(num, Number(data[index].travelData.taxi_fee)) 
               num = floatAdd(num, Number(data[index].travelData.live_fee)) 
               num = floatAdd(num, Number(data[index].travelData.travel_fee))  
               num = floatAdd(num, Number(data[index].travelData.other_fee)) 
            data[index].travelData.total = num
        },
        //付款总金额
        countDetail() {
            console.log( this.formData.detail, ' this.formData.detail.=========================')
            var num = 0
            this.formData.detail.forEach(item => {
                console.log(item[0], 'item====================')
                item.forEach(item2 => {
                    if(item2.index_name == 'detail_money') {
                         if(item2.value) {
                                num = floatAdd(num, Number(item2.value))
                                console.log(num,item2.value, 'num===================')
                            }
                    }
                })
                //  var value = Math.round( parseFloat(num) * 100 ) / 100
                 console.log(num, 'num=======================')
                //  var value = num.toString()
                //  var arrayNum = value.split(".")
                //  if ( arrayNum.length == 1) {
                //     return value + '.00'
                //     }if (arrayNum.length > 1) {
                //     if ( arrayNum[1] .length < 2) {
                //         return value + '0'
                //     }
                //     }
                this.projectMoney = num
                this.allprojectMoney = this.numFormat(num)
                console.log(this.projectMoney , 'projectMoney=====================')
            })
        },
        //有权限的部门
		handlecompany() {
			  this.account_information[0].dept_id = undefined
		    for (let i = 0; i < this.companylist.length; i++) {
			   if(this.account_information[0].company_id == this.companylist[i].deptId){
			     	this.deptList = this.companylist[i].children
				    break
			    }
		    }
		},
        //获取模板
        getModel(e) {
           this.$nextTick(() => {
            var length = this.paymentId.length - 1
            console.log(length,this.paymentId, 'length=========================')
                if(length < 2) {
                    this.paymentId = undefined
                } else {
                    // getTemplateById
                    templateList({
                        id: this.paymentId[length]
                    }).then(res => {
                        if(res.code == 200) {
                            res.data.detail[0].forEach(item => {
                                var array = []
                                if(item.type == 'Redio') {
                                    array = item.context.split(",")
                                    Object.assign(item, {
                                    array: array
                                    })
                                }
                            })
                            Object.assign(res.data.BaseInformation, {
                                tips: ''
                            })
                            res.data.detail[0].forEach( item => {
                                console.log(item ,'item=======================')
                                if(item.type === 'array') {
                                    console.log(item ,'item222222222222222=======================')
                                    Object.assign(item, {
                                        travelData: JSON.parse(JSON.stringify(this.travelData))
                                    })
                                }
                                }
                            )
                            this.formData = res.data
                            this.modelData = JSON.parse(JSON.stringify(this.formData.detail[0]))
                            var data = []
                            this.formData.BaseInformation.ccs.forEach(item => {
                                data.push(item.key)
                            })
                            this.$nextTick(() => {
                                this.$refs.ccChange.init(data)
                            })
                            console.log(this.formData, 'this.formData==========================')
                            payment_apply_code().then(res => {
                                if(res.code == 200) {
                                this.formData.applyCode = res.data
                                console.log(this.formData.applyCode,'applyCode=======================')
                                this.uploadData.code = res.data
                                this.uploadDataImg.code = res.data
                                this.billData.code = res.data
                                } else {
                                    this.$message.error(res.msg)
                                }
                            })
                            this.get_acc()
                        } else {
                            this.paymentId = undefined
                            this.$message.error(res.msg)
                        
                            return
                        }
                    })
                }
           })
        },
        //移除发票
        removeBill(index) {
            this.formData.BaseInformation.bill_information.splice(index, 1)
        },
        //添加发票
        addBill() {
          var  billModel = {
                bill_code: '', 
                bill_number: '',
                bill_check: '',
                bill_type: undefined,
                bill_money: '',
                bill_date: '',
                bill_img: [],
                bill_attach: [],
                bill_attach_id: '',
                bill_img_id: '',
            }
            this.formData.BaseInformation.bill_information.push(billModel)

        },
         //添加费用明细
        addCost() {
            this.modelData.forEach(item => {

            })
            var array = JSON.parse(JSON.stringify(this.modelData))
          this.formData.detail.push(array)
          console.log(this.formData.detail)

        },
        //删除费用明细
        deleteItem(index1) {
        this.formData.detail.splice(index1, 1)
        this.countDetail()

        },
        getdata(data) {
          this.cc = data
        },
        show(data) {
            //判断是否修改模板：修改不能重新提交
            isApply({id: data.tableId}).then(res => {
               if(res.data) {
                   this.$message.error('模板已升级，请重新申请')
               } else {
                      //获取模板
            directoryListAll({
                    type: 'payment'
                }).then((res) => {
                    this.options = res.data
               })
            //获取数据
                getPaymentDetail(data.id).then((res) => {
                    if (res.code == 200) {
                    //    this.init()
                    console.log(res.data, 'res.data=================')
                    this.formData = res.data
                    res.data.detail.forEach(item => {
                        item.forEach(item2 => {
                             if(item2.index_name == 'fee_dept') {
                                    item2.value = item2.array
                                }

                        })
                       
                    })
                      console.log(res.data, 'res.data=================')
                    this.projectMoney = this.formData.projectMoney 
                    this.allprojectMoney = this.numFormat( this.projectMoney)
                    this.formData.BaseInformation.account_information = []
                    this.applyVisible = true
                    //获取模板
                    var data  = JSON.parse(JSON.stringify(res.data.detail[0]))
                    data.forEach(item => {
                        item.value = ''
                    })
                    this.modelData  = data
                        //获取抄送人
                        var data = []
                        this.formData.BaseInformation.ccs.forEach(item => {
                            data.push(item.key)
                        })
                        this.$nextTick(() => {
                            this.$refs.ccChange.init(data)
                        })
                       //获取新的审批编号
                        payment_apply_code().then(res => {
                                if(res.code == 200) {
                                this.formData.applyCode = res.data
                                this.uploadData.code = res.data
                                this.uploadDataImg.code = res.data
                                this.billData.code = res.data
                                } else {
                                    this.$message.error(res.msg)
                                }
                            })
                            //获取账户信息
                            this.get_acc()
                        }
                })

               }
                console.log(res, 'res=================')
            })
        },
        // init() {
        //     // directoryList
        //     directoryListAll({
        //         type: 'payment'
        //     }).then((res) => {
        //        if(res.code == 200) {
        //             const list = res.data
        //         list.forEach( item => {
        //              Object.assign(item, {
        //                 value: item.id,
        //                 label: item.name,
        //                 children: item.child
        //             })
        //             if(item.child.length > 0) {
        //                 item.child.forEach(item2 => {
        //                     Object.assign(item2, {
        //                         value: item2.id,
        //                         label: item2.name,
        //                         children: item2.child
        //                     })
        //                     if(item2.child.length > 0) {
        //                         item2.child.forEach(item3 => {
        //                         Object.assign(item3, {
        //                         value: item3.id,
        //                         label: item3.name,
        //                         children: item3.child
        //                     })

        //                     })
        //                     } else {
        //                          delete item2['child']
        //                     }
        //                 })
        //             } else {
        //                 delete item['child']
        //             }
        //         })
        //         console.log(list, 'list======================')
        //          this.options = list
        //          this.applyVisible = true
        //           console.log(this.applyVisible, 'applyVisible======================')
        //        } else {
        //            this.$message.error(res.msg)
        //        }
           
        //     })
           
        // },
            //展示审批单弹窗
        showAuditCode() {
            console.log(this.purchaseData,this.approvalData, 'this.purchaseData=========================')
        this.dataDetail1 = JSON.parse(JSON.stringify(this.purchaseData)) 
        this.dataDetail2 = JSON.parse(JSON.stringify(this.approvalData))
        this.purchaseData = []
        this.approvalData = []
        this.kind = 0
        this.newApply = 1
        this.typeIndex = 2
         this.$refs.selectAuditCode.show({
        auditCodeData: this.auditCodeData,
        auditCodeData2: this.auditCodeData2,
        auditCodeData3: this.auditCodeData3,
        auditCodeData4: this.auditCodeData4,
        auditCodeData5: this.auditCodeData5,
        typeIndex: this.typeIndex,
        //selectIndex空着是否可以下拉选择
      })
        // this.$refs.selectAuditCode.init({
        //     approvalId: this.allform.approvalId,
        //     typeIndex: this.typeIndex,
        // })
            
        },
        //展示采购审批单弹窗
        showPurchase() {
            this.dataDetail1 = JSON.parse(JSON.stringify(this.purchaseData)) 
            this.dataDetail2 = JSON.parse(JSON.stringify(this.approvalData))
            this.purchaseData = []
            this.approvalData = []
            this.kind = 1
            this.newApply = 1
            this.typeIndex = 1
            // this.$refs.selectAuditCode.init({
            //     approvalId: 'purchase',
            //     typeIndex: this.typeIndex,
            // })
            this.$refs.selectAuditCode.show({
            auditCodeData: this.auditCodeData,
            auditCodeData2: this.auditCodeData2,
            auditCodeData3: this.auditCodeData3,
            auditCodeData4: this.auditCodeData4,
            auditCodeData5: this.auditCodeData5,
            typeIndex: this.typeIndex,
        })
            
            },
        //得到审批单列表
           //获取code
    getAppCode(data) {
      console.log(data, 'datadatadatadatadatadatadata')
      console.log(this.auditCodeData, 'auditCodeDataauditCodeDataauditCodeDataauditCodeData')
      this.auditCodeData = data
       data.forEach(item => {
            if(item.title) {
                    Object.assign(item, {
                        processName: item.title
                    })
                }
            // || item.procDefKey == "purchase"
            if(item.processDefKey == "purchase" ){
                console.log(item, 'item====================11111111111111')
                item.goodsData.forEach(item1 => {
                    Object.assign(item1, {
                    applyCode: item.applyCode,
                    result: item.result,
                    applyer: item.applyer,
                    applyerTime: item.applyerTime,
                    })
                     console.log(item1, 'item1111111====================11111111111111')
                    this.purchaseData.push(item1)
                })
            }else {
                this.approvalData.push(item)
            }
        })
    },
    getAppCode2(data) {
         console.log(data, 'data1111111111111111111111111')
      this.auditCodeData2 = data
       data.forEach(item => {
            if(item.title) {
                    Object.assign(item, {
                        processName: item.title
                    })
                }
            // || item.procDefKey == "purchase"
            if(item.procDefKey == "purchase" ){
                item.goodsData.forEach(item1 => {
                    Object.assign(item1, {
                    applyCode: item.applyCode,
                    result: item.result
                    })
                    this.purchaseData.push(item1)
                })
            }else {
                this.approvalData.push(item)
            }
        })
    },
    getAppCode3(data) {
        
      this.auditCodeData3 = data
      data.forEach(item => {
           if(item.title) {
                    Object.assign(item, {
                        processName: item.title
                    })
                }
                // || item.procDefKey == "purchase"
            if (item.procDefKey == "purchase") {
                    item.goodsData.forEach(item1 => {
                        Object.assign(item1, {
                        applyCode: item.applyCode,
                        result: item.result,
                        assid: item.id
                        })
                        this.purchaseData.push(item1)
                        console.log( this.purchaseData, ' this.purchaseData============================')
                    })
                }else if(item.procDefKey != "purchase") {
                    Object.assign(item, {
                        processName: item.title,
                        applyerTime: item.applyTime
                    
                    })
                    this.approvalData.push(item)
                }
            })
    },
    getAppCode4(data) {
        
      this.auditCodeData4 = data
      data.forEach(item => {
                if(item.title) {
                    Object.assign(item, {
                        processName: item.title
                    })
                }
                // || item.procDefKey == "purchase"
            if (item.procDefKey == "purchase") {
                    item.goodsData.forEach(item1 => {
                        Object.assign(item1, {
                        applyCode: item.applyCode,
                        result: item.result,
                        assid: item.id
                        })
                        this.purchaseData.push(item1)
                    })
                }else if(item.procDefKey != "purchase") {
                    Object.assign(item, {
                        processName: item.title,
                        applyerTime: item.applyTime
                    
                    })
                    this.approvalData.push(item)
                }
            })
    },
     getAppCode5(data) {
      this.auditCodeData5 = data
      data.forEach(item => {
            if(item.title) {
                    Object.assign(item, {
                        processName: item.title
                    })
                }
                // || item.procDefKey == "purchase"
            if (item.procDefKey == "purchase") {
                    item.goodsData.forEach(item1 => {
                        Object.assign(item1, {
                        applyCode: item.applyCode,
                        result: item.result,
                        assid: item.id
                        })
                        this.purchaseData.push(item1)
                    })
                }else if(item.procDefKey != "purchase") {
                    Object.assign(item, {
                        processName: item.title,
                        applyerTime: item.applyTime
                    
                    })
                    this.approvalData.push(item)
                }
            })
    },
        // getAppCode1(data) {
        //     console.log(data, 'data========================')
            
        // console.log(this.approvalData, this.purchaseData, 'approvalData, this.purchaseData==============================')
        // },
        // getAppCode(data) {
       
        // console.log(this.approvalData, this.purchaseData, 'approvalData, this.purchaseData==============================')
        // },
        //取消关联
        approvalDelete(record, index) {
        this.approvalData.splice(index, 1)
         for(var i = 0; i <  this.auditCodeData.length; i++) {
            if(this.auditCodeData[i].applyCode == record.applyCode) {
                this.auditCodeData.splice(i, 1)
            }
        }
        for(var i = 0; i <  this.auditCodeData4.length; i++) {
            if(this.auditCodeData4[i].applyCode == record.applyCode) {
                this.auditCodeData4.splice(i, 1)
            }
        }
         for(var i = 0; i <  this.auditCodeData5.length; i++) {
            if(this.auditCodeData5[i].applyCode == record.applyCode) {
                this.auditCodeData5.splice(i, 1)
            }
        }
        for(var i = 0; i <  this.auditCodeData2.length; i++) {
            console.log(this.auditCodeData2,i,'this.auditCodeData2===================')
            if(this.auditCodeData2[i].applyCode == record.applyCode) {
                this.auditCodeData2.splice(i, 1)
            }
        }
        console.log( this.auditCodeData2, ' this.auditCodeData2.=======================')
        for(var i = 1; i <  this.auditCodeData3.length; i++) {
            if(this.auditCodeData3[i].applyCode == record.applyCode) {
                this.auditCodeData3.splice(i, 1)
            }
        }
        },
        purchaseDelete(record, index) {
            for(var i = this.purchaseData.length - 1; i >= 0; i--) {
                 console.log(this.purchaseData[i],record,i, 'this.purchaseData[i]====================')
                 if(record.applyCode ==  this.purchaseData[i].applyCode) {
                      this.purchaseData.splice(i, 1)
                 }
            }
            console.log(record, 'record====================')
       
        for(var i = 0; i <  this.auditCodeData.length; i++) {
              console.log(this.auditCodeData,i,'this.auditCodeData===================')
            if(this.auditCodeData[i].applyCode == record.applyCode) {
                 console.log(this.auditCodeData,i,'this.auditCodeData===================')
                this.auditCodeData.splice(i, 1)
            }
        }
        for(var i = 0; i <  this.auditCodeData4.length; i++) {
            if(this.auditCodeData4[i].applyCode == record.applyCode) {
                this.auditCodeData4.splice(i, 1)
            }
        }
         for(var i = 0; i <  this.auditCodeData5.length; i++) {
            if(this.auditCodeData5[i].applyCode == record.applyCode) {
                this.auditCodeData5.splice(i, 1)
            }
        }
        for(var i = 0; i <  this.auditCodeData2.length; i++) {
            console.log(this.auditCodeData2,i,'this.auditCodeData2===================')
            if(this.auditCodeData2[i].applyCode == record.applyCode) {
                this.auditCodeData2.splice(i, 1)
            }
        }
        console.log( this.auditCodeData2, ' this.auditCodeData2.=======================')
        for(var i = 0; i <  this.auditCodeData3.length; i++) {
            if(this.auditCodeData3[i].applyCode == record.applyCode) {
                this.auditCodeData3.splice(i, 1)
            }
        }
      

        },
        getdata(data) {
            this.cc = data

        },
        onClose() {
            this.bill_information = [{
                bill_code: '', 
                bill_number: '',
                bill_check: '',
                bill_type: undefined,
                bill_money: '',
                bill_date: '',
                bill_img: [],
                bill_attach: [],
                bill_attach_id: '',
                bill_img_id: '',
            }],
            this.information_relate = [
                {
                    project_name: '',
                    project_code: '',
                    projece_pay: '',
                    amount: '',
                }
            ],
            
            this.account_information[0].reimbursement_account = undefined
            // this.department_id = []
             if(this.formData.detail) {
                 this.formData.detail.forEach(item => {
                        item.forEach(item2 => {
                            if(item2.type == 'array') {
                                item2.travelData = {}
                            }
                        })
                    })
             }
            // formData.detail
             this.approvalId = undefined
             this.remark = ''
            this.options = []
            this.purchaseData = []
            this.approvalData = []
            this.auditCodeData = [],
            this.auditCodeData2 = [],
            this.auditCodeData3 = [],
            this.auditCodeData4 = [],
            this.auditCodeData5 = [],
            this.paymentId = undefined
            this.applyVisible = false
            this.allprojectMoney = 0
            this.projectMoney = 0

        },
        submit() {
            var mustData = true
            // var companyName = ''
            // var deptName = ''
            // this.companylist.forEach(item => {
            //     if(this.account_information[0].company_id == item.companyId) {
            //         companyName = item.companyName
            //         item.children.forEach
            //     }
                // 支付宝
                // 个人银行卡
            // })对公银行账号
            //修改费用金额日期
            this.formData.detail.forEach(item => {
                item.forEach(item2 => {
                    if(item2.type == 'array') {
                        if(item2.travelData.location_end) {
                             item2.travelData.location_end =  item2.travelData.location_end.join('/')
                        }
                        if(item2.travelData.location_start) {
                            item2.travelData.location_start = item2.travelData.location_start.join('/')
                        }
                    }
                })
            })
            console.log(this.formData, 'formData=======================')
            var bank = {}
            var type = ['支付宝','个人银行卡','对公银行账号']
            console.log(this.account_information[0].reimbursement_account, 'this.account_information[0].reimbursement_account====================')
            this.banklist.forEach(item => {
                console.log(item, 'item=========================')
                if(item.id == this.account_information[0].reimbursement_account) {
                    console.log(item, 'item========================')
                    Object.assign(bank, {
                        accountNum: item.accountNum,
                        bank: item.bank,
                        name: item.name,
                        accountTypeIdx: type[item.accountType],
                        address: item.provinceName + item.cityName,
                        branchBank: item.branchBank
                    })
                }
            })
             var array = {
                 subjectionDeptId:  this.account_information[0].dept_id,
                 company_id:  this.account_information[0].company_id,
                 apply: this.account_information[0].apply,
                 reimbursement_account:  bank,
             }
             var ccsusers = []
             var data = this.cc
             console.log(this.cc, 'this.cc============')
              console.log(this.ccsData, 'this.ccsData============')
            //  var data = this.cc.split(',')
             this.ccsData.forEach(item => {
                 data.forEach(item1 => {
                     if(item.userId == item1) {
                         ccsusers.push(item)
                     }

                 })
                 
             })
            Object.assign( this.formData.BaseInformation, {
                // department_id: this.department_id,
                // paymentId: this.paymentId,
                // information_relate: this.information_relate,
                // bill_information: this.bill_information,
                account_information: array,
                approvalData: this.approvalData,
                purchaseData: this.purchaseData,
                ccsusers: ccsusers,
                cc: this.cc.join(',')
            })

            console.log( this.formData, this.paymentId,' this.formData.==========')
            this.formData.projectMoney = this.projectMoney
            // 校验费用明细
            this.formData.detail.forEach(item2 => {
                item2.forEach(item3 => {
                    if(item3.required) {
                        if(!item3.value) {
                            console.log(item3, 'item3================')
                        this.$message.warning('付款明细必填字段不能为空！')
                        return mustData = false
                        }
                    }
                })

            })
            if(this.formData.BaseInformation.isCheckBill) {
            var list = this.formData.BaseInformation.bill_information
            list.forEach(item1 => {
                if(item1.bill_code == '' || item1.bill_number == '') {
                        this.$message.warning('发票信息必填字段不能为空！')
                        return mustData = false
                    } 
                })

            }
            if(this.formData.BaseInformation.isCheckInformation) {
                this.formData.BaseInformation.information_relate.forEach(
                    item => {
                        if(!item.projece_pay) {
                            this.$message.warning('关联项目金额不能为空！')
                            return mustData = false
                        }
                    }
                )
            }
            if (this.formData.BaseInformation.account_information) {
                    var data = this.formData.BaseInformation.account_information
                console.log(data, 'data===============')
                console.log(typeof(data.company_id), 'typeof(data.company_id)=================')
                if(typeof(data.company_id) == "undefined" || typeof(data.subjectionDeptId) == "undefined" || JSON.stringify(data.reimbursement_account) === '{}') {
                     this.$message.warning('申请人/账户信息必填字段不能为空！')
                    return mustData = false
                }

            } 
            if(mustData) {
                postApply(this.formData).then(res => {
                if(res.code == 200) {
                    this.$message.success(res.msg)
                    this.$emit('getData')
                     this.formData.BaseInformation.bill_information = [{
                        bill_code: '', 
                        bill_number: '',
                        bill_check: '',
                        bill_type: undefined,
                        bill_money: '',
                        bill_date: '',
                        bill_img: [],
                        bill_attach: [],
                        bill_attach_id: '',
                        bill_img_id: '',
                    }],
                    this.formData.BaseInformation.information_relate = [
                        {
                            project_name: '',
                            project_code: '',
                            projece_pay: '',
                            amount: '',
                        }
                    ],
                    this.account_information[0].reimbursement_account = undefined
                    this.formData.detail.forEach(item => {
                        item.forEach(item2 => {
                            if(item2.type == 'array') {
                                item2.travelData = {}
                            }
                        })
                    })
                    this.approvalId = undefined
                    this.purchaseData = []
                    this.approvalData = []
                    this.auditCodeData = [],
                    this.auditCodeData2 = [],
                    this.auditCodeData3 = [],
                    this.auditCodeData4 = [],
                    this.auditCodeData5 = [],
                    this.options = []
                    this.paymentId = undefined
                    this.applyVisible = false
                    this.projectMoney = 0
                    this.allprojectMoney = 0
                } else {
                    this.$message.error(res.msg)
                }
            })

                }

        },

    },

}
</script>

<style lang="less" scoped>
.rightTop {
    display: flex;
    justify-content: space-between;
    a {
        color: #767575;
    }
}
.box {
    margin-top: 10px;

}
.boxCenter {
     margin-top: 10px;
    padding: 10px 10px 30px 10px;
}
.centerBox {
    margin-top: 10px;
    padding: 10px;
}
.relationBox {
    padding: 10px;
}
.title {
    font-weight: 700;
    /* float: left; */
    margin-left: 0px;
    color: black;

}
.center {
    margin: 20px;
    display: flex;
    justify-content: space-between
}
.centerBottom {
    margin-top: 10px;
    .bottom {
        padding: 10px;
    }
    margin-bottom: 50px;
     

}
/deep/ .line{
            color: #f5222d !important;
        }
.center div{
    width: 50%;

}
.backBox {
     position: absolute;
    width:500px;
    height:500px;
    top: 50%;
    left: 50%;
    margin: -150px 0 0 -250px;  /* 外边距为自身宽高的一半 */
    .boxTop {
        margin-top: 10px;
        padding: 10px;
        widows: 100%;
        height: 100px;
        background-color: #D4E3FB;

    }
}

.containerTop {  
    .center {
      .box {
            width: 200px;
            height: 45px;
            background: rgba(0,0,0,.2) !important;
            // background-color: rgb(202, 38, 38);
            height: 30px;
            color:white;
        }
    }

}
.expenses {
    .expensesTitle {
    font-weight: 700;
    margin-left: 0px;
    margin-bottom: 10px;
    color: black;
    display: flex;
    justify-content: space-between;
    margin-right: 10px;
    }


}
.expensesTop {
    padding: 10px 10px 0px 10px;
    font-size: 18px;
    display: flex;
    justify-content: space-between;

}
.expensesCenter {
    padding: 5px 25px 25px 50px;
}
.xuxian1 {
    margin: 0 30px;
    width: 100%;
    height:0;
    border-bottom: #BBBBBB  1px dashed;
    margin: 12px 0;

}
.xuxian{
    width: 85%;
    height:0;
    border-bottom: #BBBBBB  1px dashed;
    margin: 12px 0;
    }
.feeDetail {
  display:flex;
  justify-content: center;
  .addFee {
      width: 60%;
      margin-top: 10px;
      border-color: #409EFF !important;
      color: #409EFF !important;
      margin-bottom: 20px;


      &:hover {
        background: #e2f1ff !important;
      }
}

}
.invoiceBox {
    margin-top: 10px;
    .invoiceCenter {
        margin-top: 20px;
    }
    .billBottom {
        display:flex;
        justify-content: center;
          margin-top: 20px;
        .addBill {
            width: 60%;
            margin-top: 20px;
            border-color: #409EFF !important;
            color: #409EFF !important;
            margin-bottom: 20px;
      &:hover {
        background: #e2f1ff !important;
      }
  }



}


}
.colLeft {
    text-align: center;
    line-height: 50px;
}
.colRight {
    padding: 10px;
}
.topBox {
  width: 100%;
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .topItem {
    float: left;
    margin-right: 25px;
    cursor: pointer;
    &:hover {
      color: #74b9fd;
    }
  }
}
.centerBank {
  width: 80%;
//   float: left;
  margin-top: 40px;
  .c_item {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
    .title {
      width: 90px;
      float: left;
      text-align: right;
    }
    .aInput {
      width: 300px;
    }
    .selectAds {
      width: 150px;
      float: left;
    }
  }
}
.travelBoxTop {
    border: 1px solid #dedfdf;
    height: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
}
 .travelContetTop {
            background-color: #EDF1F2 ;
            height: 50px;
            line-height: 50px;
            text-align: center;
            box-sizing: border-box;

        }
 .borderStyle {
      border-left: 1px solid #dedfdf;
      border-right: 1px solid #dedfdf;
        }
 .borderBottom {
      border-bottom: 1px solid #dedfdf;
 }
.layoutbox {
        display: flex; 
        flex-direction: row; 
        flex-wrap: nowrap;
        border-Top: 1px solid #dedfdf;
        box-sizing: border-box;

}
.travelContetBottom {
    padding: 10px;
}
.travelBoxCenter {
    height: 153px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    box-sizing: border-box;

}
.travelCenter {
    height: 50px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
   .contener {
       line-height: 49px;
       text-align: center;
       width: 18%;
       border-right: 1px solid #dedfdf;
       background-color: #EDF1F2
       
   }
   .bottomBox {
        line-height: 49px;
       text-align: center;
       width: 27%;
       border-right: 1px solid #dedfdf;
       background-color: #EDF1F2

   }
     .contenerBox {
      width: 32%;
      border-right: 1px solid #dedfdf;

   }
   .contenerCenter {
    //    line-height: 49px;
    //    text-align: center;
       width: 40%;
       padding: 10px;
       border-right: 1px solid #dedfdf;
       
   }

}

//  .block {
//         width: 5px;
//         height: 24px;
//         background: #2479e2;
//         margin-right: 15px;
//       }
// <!--只允许输入整数-->
 
// <input type="text" name="verif" oninput="value=value.replace(/[^\d]/g,'')" >
 
// <!--只允许输入整数和小数（小数只保留小数点后两位）-->
 
// <input type="text" name="verif" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" >
 
// <!--限制只能输入正数、小数、负数-->
// <input type="text" name="verif" oninput="this.value=this.value.replace(/[^\-?\d.]/g,'')"/>


</style>